import React, { useState } from 'react';
import { ImproveChatModal } from './ImproveChatModal';

// Icône personnalisée « Assistant Progrès » : bulle de dialogue + courbe ascendante
// (donner un retour = faire progresser l'outil). Pas une simple étoile.
const ProgressIcon = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 4h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8l-5 4v-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
    <path d="M7 13l2.6-2.6 2 2L16 8" />
    <path d="M13.4 8H16v2.6" />
  </svg>
);

// Bouton flottant « Améliorer » présent sur toutes les pages authentifiées.
export const ImproveButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="improve-fab"
        onClick={() => setOpen(true)}
        aria-label="Améliorer l'outil"
        className="fixed z-[80] right-4 bottom-[calc(var(--regulatory-h)+16px)] flex items-center gap-2 pl-3.5 pr-4 py-3 rounded-full bg-gradient-to-br from-violet-600 to-fuchsia-600 text-white shadow-lg shadow-violet-900/40 hover:-translate-y-0.5 active:scale-95 transition-all"
      >
        <ProgressIcon className="w-5 h-5" />
        <span className="text-sm font-medium hidden sm:inline">Améliorer</span>
      </button>
      <ImproveChatModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
